import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getEmailConfiguration, updateEmailConfiguration } from 'services/apis/conditions'
import { Modal } from 'stories/components'
import { InputConvert, InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { emailConfigurationInputs } from './constants'

export const EmailConfiguration = ({ onClose }: { onClose: Function }) => {
  const [loading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(emailConfigurationInputs())
  const [data, setData] = useState<Record<string, any>>({})

  useEffect(() => {
    getEmailConfiguration().then((res) => {
      setData(res)
      const updatedInputs = cloneDeep(inputs)

      Object.keys(res).forEach((key) => {
        if (updatedInputs[key]) updatedInputs[key].value = res[key]
      })
      setInputs(updatedInputs)
    })
  }, [])

  const onChange = (key: string, value: string) => {
    let newInputs = cloneDeep(inputs)
    value = InputConvert(newInputs[key], value)
    newInputs[key].error = InputValidate({ ...newInputs[key], value })
    newInputs[key].value = value
    setInputs(newInputs)
  }

  const onChangeVisible = (key: string) => {
    const temp = cloneDeep(data)
    temp.visible[key] = !data.visible[key]
    setData(temp)
  }

  const onSubmit = () => {
    let hasError = false

    let newInputs = cloneDeep(inputs)
    const _data: Record<string, any> = {}
    for (const key in inputs) {
      newInputs[key].error = InputValidate(newInputs[key])
      _data[key] = newInputs[key].value
      if (newInputs[key].error) hasError = true
    }
    if (hasError) return
    _data.visible = data.visible

    setLoading(true)
    updateEmailConfiguration(_data)
      .then(async () => {
        toast('Social media links has been saved successfully.', { type: 'info' })
        onClose()
      })
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      title="Email Configuration"
      titleOkay="Submit"
      loading={loading}
      onClose={() => onClose(false)}
      onOk={onSubmit}
      isOpen
    >
      <div className="text-gray-900 w-144">
        <div className="italic border-b w-full mb-4 border-gray-300">- Social Webiste URLS</div>
        <div className="grid grid-cols-2 gap-4">
          {Object.keys(inputs).map((key, index) => {
            const input = inputs[key]
            const visible = data.visible?.[key]
            input.additionalElements = (
              <span className="text-shade-blue cursor-pointer" onClick={() => onChangeVisible(key)}>
                {visible ? <EyeIcon className="w-4 h-4" /> : <EyeSlashIcon className="w-4 h-4" />}
              </span>
            )
            return (
              <div className={`input ${visible ? 'opacity-100' : 'opacity-30 z-10'}`} key={index}>
                <RenderInput input={input} Key={key} onChange={onChange} />
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  )
}
